import { render, staticRenderFns } from "./PhotoPreviewer.vue?vue&type=template&id=66a2d99c&scoped=true&"
import script from "./PhotoPreviewer.vue?vue&type=script&lang=js&"
export * from "./PhotoPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPreviewer.vue?vue&type=style&index=0&id=66a2d99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a2d99c",
  null
  
)

export default component.exports